<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-04 17:10:37
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2019-07-10 11:40:10
 * @Description: file content
 -->
<template>
  <div class="container">
    <iframe id="editContentFrame" :src="url" frameborder="0" :width="width" :height="height"></iframe>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    width: "",
    height: "",
    content: ""
  },
  data() {
    return {
      url: "",
      myFrame: null
    };
  },
  watch: {},
  computed: {},
  methods: {
    getContent() {
      if (this.myFrame) {
        return this.myFrame.getContent();
      }
    }
  },
  created() {},
  mounted() {
    if (this.global.isLoc) {
      this.url =
        "http://localhost:8080/shqc-web/activities/build-page/editor_hdk.html?fake=qmyx_hope";
    } else {
      this.url = `https://${location.host}/activities/build-page/editor_hdk.html?v=4`;
    }

    let tmpInterval = setInterval(() => {
      if (
        document.getElementById("editContentFrame").contentWindow.window
          .setContent
      ) {
        this.myFrame = document.getElementById(
          "editContentFrame"
        ).contentWindow.window;
        this.myFrame.setContent(this.content);
        clearInterval(tmpInterval);
      }
    }, 100);
  }
};
</script>
<style lang="css" scoped>
.container {
  z-index: 20;
}
</style>